// extracted by mini-css-extract-plugin
export default {"layoutOuterContent":"style_layoutOuterContent__v5w9y","layoutInnerContent":"style_layoutInnerContent__f4FJD","layoutInnerContentMobile":"style_layoutInnerContentMobile__a7EDF"};